module.exports = __webpack_public_path__ + "img/qrcode.ad63da60.svg";